export default __webpack_public_path__ + "images/ML.f1fdc15.png";